import normalizeCta from '@models/CTA'
import normalizeImage from '@models/Image'
import normalizePolicy from '@models/Policy'

const Banner = ({
  tagline,
  title,
  paragraph,
  image,
  bulletPoints,
  ctaPrimary,
  ctaSecondary,
  variant,
  theme = 'white',
  video,
  colorScheme,
  policies,
}) => {
  const normalizedData = {
    tagline,
    title,
    paragraph,
    image: normalizeImage(image),
    bulletPoints,
    ctaPrimary: normalizeCta(ctaPrimary),
    ctaSecondary: normalizeCta(ctaSecondary),
    variant,
    theme,
    video,
    colorScheme,
    policies: policies || [],
  }

  return normalizedData
}

export default Banner
